import { useEffect, useId, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/comn";
import { Icon, Badge } from "@/comn/components";

export const HeaderTodoButton = () => {
    const id = useId();
    const [data, setData] = useState([]);

    useEffect(() => {
        getTodo();
        const intervalId = setInterval(() => {
            getTodo();
        }, 300000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const getTodo = async () => {
        try {
            let base = "",
                path = "";
            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tancis":
                    base = process.env.REACT_APP_API_PTLI || "";
                    path = "/api/v1/ptli/intptl/mypage/todo/main";
                    break;
                case "tanoga":
                    base = process.env.REACT_APP_URL_ESWO || "";
                    path = "/api/v1/eswo/oagptl/mypage/todo/main";
                    break;
            }
            const response = await api.get(base + path);
            setData(response.data.todoList.content);
        } catch (error) {
            // console.log(error);
        }
    };

    const number = data.length || undefined;

    return (
        <div className="group relative">
            <Badge number={number}>
                <button
                    type="button"
                    className="flex items-center justify-center bg-header rounded h-[32px] w-[32px] hover:bg-black/10 transition-colors"
                >
                    <Icon icon="list" />
                </button>
            </Badge>
            {number && (
                <div className="z-[9999] absolute border shadow top-full left-0 w-60 rounded bg-navigation hidden group-hover:block">
                    <div className="p-2 text-lg font-bold">{number}개의 메세지가 있습니다</div>
                    <ul className="divide-y max-h-[480px] overflow-y-auto">
                        {data.map(({ todoBsopDvn, frstRgsrDtm, dmn }: any, index) => {
                            return (
                                <li
                                    key={id + index}
                                    className="p-2 cursor-pointer hover:bg-background [&_div]:hover:underline"
                                >
                                    <Link to={dmn}>
                                        <span className="text-sm text-darkgray">{frstRgsrDtm}</span>
                                        <div className="font-semibold">{todoBsopDvn}</div>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};
